import { useCallback, useEffect, useState } from 'react';
import FeatureFlagManager from './FeatureFlagManager';
export const useFeatureFlag = (flag) => {
    const [val, setVal] = useState(FeatureFlagManager.isEnabled(flag));
    const onFlagsChanged = useCallback(() => {
        setVal(FeatureFlagManager.isEnabled(flag));
    }, [flag]);
    useEffect(() => {
        FeatureFlagManager.on('change', onFlagsChanged);
        onFlagsChanged();
        return () => {
            FeatureFlagManager.off('change', onFlagsChanged);
        };
    }, [onFlagsChanged]);
    return val;
};
